import React from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import SaxsAbInitioUpperPanel from './helpers/SaxsAbInitioUpperPanel';
import SaxsSubtractionsContainer from './helpers/SaxsSubtractionsContainer';
import SaxsAbInitioFittingDataContainer from './helpers/SaxsAbInitionFittingDataContainer';
import { FITTING_METHOD_FIR, FITTING_METHOD_FIT } from '../../constants/saxs';
import SaxsAbInitioTable from '../../components/saxs/SaxsAbInitioTable';
import SaxsAbInitioPDBContainer from './helpers/SaxsAbInitioPDBContainer';
import SaxsAbInitioPDBViewer from '../../components/saxs/SaxsAbInitioPDBViewer';
import SaxsDataCollectionsContainer from './helpers/SaxsDataCollectionsContainer';

class SaxsAbInitioContainer extends React.Component {
    render() {
        return (
            <div style={{ paddingBottom: '70px' }}>

                <SaxsDataCollectionsContainer dataCollectionId={this.props.dataCollectionId} proposal={this.props.proposal} token={this.props.user.token} >
                    {dataCollections => {
                        if (dataCollections && dataCollections instanceof Array && dataCollections.length > 0) {
                            return (<SaxsSubtractionsContainer subtractionIds={dataCollections[0].subtractionId} proposal={this.props.proposal} token={this.props.user.token} >
                                {(subtractions) => {
                                    if (subtractions && subtractions instanceof Array && subtractions.length > 0) {
                                        return (<div>
                                            <SaxsAbInitioFittingDataContainer fittingMethod={FITTING_METHOD_FIR} subtraction={subtractions[0]} proposal={this.props.proposal} token={this.props.user.token}>
                                                {firData => {
                                                    return (<SaxsAbInitioFittingDataContainer fittingMethod={FITTING_METHOD_FIT} subtraction={subtractions[0]} proposal={this.props.proposal} token={this.props.user.token}>
                                                        {fitData => {
                                                            return <SaxsAbInitioUpperPanel firContent={firData} fitContent={fitData} subtraction={subtractions[0]} token={this.props.user.token} />
                                                        }}
                                                    </SaxsAbInitioFittingDataContainer>)
                                                }}
                                            </SaxsAbInitioFittingDataContainer>

                                            <Grid fluid>
                                                <Row>
                                                    <Col xs={12} md={12} lg={3}>
                                                        <SaxsAbInitioPDBContainer subtraction={subtractions[0]} proposal={this.props.proposal} token={this.props.user.token}>
                                                            {data => {
                                                                return <SaxsAbInitioPDBViewer data={data} />
                                                            }}
                                                        </SaxsAbInitioPDBContainer>
                                                    </Col>
                                                    <Col xs={12} md={12} lg={9}>
                                                        <SaxsAbInitioTable subtractions={subtractions} proposal={this.props.proposal} token={this.props.user.token} />
                                                    </Col>
                                                </Row>
                                            </Grid>
                                        </div>)
                                    }

                                    return null;
                                }}
                            </SaxsSubtractionsContainer>)
                        }

                        return null;
                    }}

                </SaxsDataCollectionsContainer>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}


export default connect(mapStateToProps, () => null)(SaxsAbInitioContainer);


// WEBPACK FOOTER //
// ./src/containers/saxs/SaxsAbInitioContainer.js